import React, { useState, useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import { isMobile } from "react-device-detect";

import DownloadButtons from "../components/DownloadButtons";
import TermsFooter from "./TermsFooter";

import { colors } from "../../../../styles/customStyles";
import icon from "../../../../../static/media/logo/icon.png";

import ReefBackground from "./reef/ReefBackground";

function useViewport() {
  const [vp, setVp] = useState(() => ({
    w: typeof window !== "undefined" ? window.innerWidth : 1200,
    h: typeof window !== "undefined" ? window.innerHeight : 800,
  }));

  useEffect(() => {
    const onResize = () => setVp({ w: window.innerWidth, h: window.innerHeight });
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return vp;
}

const HomePageSimple = () => {
  const isNarrow = useMediaQuery("(max-width: 899px)");
  const { w, h } = useViewport();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!loaded) {
      const t = setTimeout(() => setLoaded(true), 500);
      return () => clearTimeout(t);
    }

    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.fooge.app";
    } else if (/iPad|iPhone|iPod/.test(ua)) {
      window.location.href =
        "https://apps.apple.com/us/app/id1636884270";
    }
  }, [loaded]);

  return (
    <>
      {/* hard reset so you NEVER get the white frame */}
      <style>{`
        html, body, #app { height: 100%; width: 100%; margin: 0; padding: 0; }
        body { overflow: hidden; }
      `}</style>

      <div
        style={{
          position: "fixed",
          inset: 0,
          width: "100vw",
          height: "100dvh",
          overflow: "hidden",
        }}
      >
        <ReefBackground width={w} height={h} withfish={true}>
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              boxSizing: "border-box",
            }}
          >
            {/* Centered content */}
            <div
              style={{
                flex: "1 1 auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0 20px",
              }}
            >
              <div style={{ width: "100%", maxWidth: 900, textAlign: "center" }}>
                <img
                  src={icon}
                  alt="Inner Reef icon"
                  style={{ width: 50, marginTop: isNarrow ? 40 : 10 }}
                />

                <p
                  className="iconfont"
                  style={{
                    color: colors.turtlelight,
                    marginTop: 5,
                    textAlign: "center",
                  }}
                >
                  Inner Reef
                </p>

                <h2 style={{ color: colors.light, marginTop: 20 }}>
                  The Self-Connection Game
                </h2>

                <p
                  style={{
                    color: colors.light,
                    maxWidth: 700,
                    margin: "12px auto 20px",
                    fontSize: 14, textAlign:'center'
                  }}
                >The Self-Connection Game where listening to your emotions builds the self-knowledge and self-regulation you need to restore your Inner Reef and confidently navigate whatever life brings.
                </p>

                <DownloadButtons small={isMobile} notcentered />
              </div>
            </div>

            {/* Footer pinned */}
            <div
              style={{
                flex: "0 0 auto",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                padding: "12px 0 14px",
              }}
            >
              <div style={{ width: "100%", maxWidth: 1100, padding: "0 16px" }}>
                <TermsFooter isXs={true} />
              </div>
            </div>
          </div>
        </ReefBackground>
      </div>
    </>
  );
};

export default HomePageSimple;
